(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4331],{

/***/ 22352:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jargon/[slug]",
      function () {
        return __webpack_require__(62931);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* reexport safe */ _cinch_nx_landing_feature_jargon__WEBPACK_IMPORTED_MODULE_0__.lp; }
/* harmony export */ });
/* harmony import */ var _cinch_nx_landing_feature_jargon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88840);
var __N_SSG = true;



/***/ }),

/***/ 88840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lp": function() { return /* reexport */ JargonFeature; },
  "zQ": function() { return /* reexport */ RelatedJargon; }
});

// UNUSED EXPORTS: getStaticPathsGenerator, getStaticPropsGenerator, jargonStaticPaths

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 54 modules
var src = __webpack_require__(83624);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 266 modules
var shared_src = __webpack_require__(2388);
// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/lib/components/keyword-list/keyword-list.module.css
var keyword_list_module = __webpack_require__(55257);
var keyword_list_module_default = /*#__PURE__*/__webpack_require__.n(keyword_list_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/components/keyword-list/keyword-list.tsx




const KeywordList = ({ items  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (keyword_list_module_default()).keywords,
        "data-testid": "jargon-keywords",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (keyword_list_module_default()).header,
                children: "Keywords"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (keyword_list_module_default()).list,
                children: items && items.map((keyword, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (keyword_list_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: `/jargon?q=${keyword}`,
                            passHref: true,
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextLink */.hh, {
                                className: (keyword_list_module_default()).link,
                                children: keyword
                            })
                        })
                    }, index))
            })
        ]
    });

// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/lib/components/jargon-content/jargon-content.module.css
var jargon_content_module = __webpack_require__(90197);
var jargon_content_module_default = /*#__PURE__*/__webpack_require__.n(jargon_content_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/components/jargon-content/jargon-content.tsx





const JargonContent = ({ question , answer , image  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (jargon_content_module_default()).article,
        "data-testid": "jargon-article",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (jargon_content_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (jargon_content_module_default()).question,
                        children: question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* RichTextStyles */.Px, {
                        children: [
                            (0,shared_src/* renderWithResolver */.be)(answer),
                            " "
                        ]
                    })
                ]
            }),
            image && image.filename && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (jargon_content_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image.filename,
                    className: (jargon_content_module_default()).jargonImage,
                    layout: "responsive",
                    width: 592,
                    height: 310,
                    objectFit: "contain"
                })
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/lib/components/related-jargon/related-jargon.module.css
var related_jargon_module = __webpack_require__(16970);
var related_jargon_module_default = /*#__PURE__*/__webpack_require__.n(related_jargon_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/components/related-jargon/related-jargon.tsx





const RelatedJargon = ({ items  })=>{
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: (related_jargon_module_default()).related,
        "data-testid": "jargon-list",
        children: items.length > 0 && items.filter((item)=>item && item.content).map((item, index)=>{
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(shared_src/* Panel */.s_, {
                title: (ref = item.content) === null || ref === void 0 ? void 0 : ref.question,
                subtitle: (ref1 = item.content) === null || ref1 === void 0 ? void 0 : ref1.summary,
                isPadded: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (related_jargon_module_default()).link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: `/jargon/${item.slug}`,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Secondary */.T7, {
                            element: "a",
                            "data-testid": "jargonLink",
                            className: (related_jargon_module_default()).button,
                            children: "Read more"
                        })
                    })
                })
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/components/index.ts




// EXTERNAL MODULE: ../../../libs/landing/feature-jargon/src/lib/jargon.module.css
var jargon_module = __webpack_require__(68740);
var jargon_module_default = /*#__PURE__*/__webpack_require__.n(jargon_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/utils/is-jargon-hub-story-content.ts
const isJargonHubStoryContent = (input)=>{
    const isJargonPage = Object.prototype.hasOwnProperty.call(input, "component") && input.component === "JargonPage";
    if (!isJargonPage) {
        console.error(`Expected to find JargonPage component, instead received: \n ${JSON.stringify(input, null, 2)}`);
    }
    return isJargonPage;
};

// EXTERNAL MODULE: ../../../node_modules/@mui/material/Skeleton/Skeleton.js + 12 modules
var Skeleton = __webpack_require__(78840);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/jargon.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/jsx-no-target-blank */ 










const siteUrl = "https://www.cinch.co.uk/";
const JargonFeature = ({ story , preview =false  })=>{
    var ref;
    const prefersReducedMotion = (0,src/* usePrefersReducedMotion */.Tb)();
    const { content , slug  } = (0,storyblok_src/* useStoryblokState */.f0)({
        story: story,
        enableBridge: preview
    });
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    if (!content || !isJargonHubStoryContent(content) || !story) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: (jargon_module_default()).page,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Wrapper */.im, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        sx: {
                            marginTop: "24px",
                            marginBottom: "16px"
                        },
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        width: 500,
                        height: 56
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        sx: {
                            marginBottom: "56px"
                        },
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        width: 300,
                        height: 30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        className: (jargon_module_default()).skeleton
                    })
                ]
            })
        });
    } else {
        var ref1;
        const { fullTerm , term , question , answer , image , keywords , summary  } = content;
        const reducedRelatedJargon = (ref1 = story.rels) === null || ref1 === void 0 ? void 0 : ref1.map((relatedStory)=>{
            var ref, ref1, ref2, ref3;
            return {
                slug: relatedStory.slug ?? "",
                content: {
                    summary: ((ref = relatedStory.content) === null || ref === void 0 ? void 0 : ref.summary) ?? "",
                    question: ((ref1 = relatedStory.content) === null || ref1 === void 0 ? void 0 : ref1.question) ?? "",
                    keywords: ((ref2 = relatedStory.content) === null || ref2 === void 0 ? void 0 : ref2.keywords) ?? "",
                    fullTerm: ((ref3 = relatedStory.content) === null || ref3 === void 0 ? void 0 : ref3.fullTerm) ?? ""
                }
            };
        });
        const keywordList = keywords === null || keywords === void 0 ? void 0 : keywords.split(",").map((p)=>p.trim());
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                    ...SEO,
                    fallbackTitle: `${fullTerm} - cinch`,
                    fallbackDescription: summary
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    className: (jargon_module_default()).page,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Wrapper */.im, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (jargon_module_default()).header,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/jargon",
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: (jargon_module_default()).headerLink,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                                    name: "chevron-left",
                                                    height: 12,
                                                    color: "toreaBay"
                                                }),
                                                "All Jargon"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: `mailto:?subject=${question} - Cinch&body=${siteUrl}/jargon/${slug}`,
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            target: "_blank",
                                            className: (jargon_module_default()).headerLink,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                                    name: "share",
                                                    height: 16,
                                                    gradient: "newGalaxy"
                                                }),
                                                "Share by Email"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: (jargon_module_default()).fullTerm,
                                children: [
                                    fullTerm,
                                    term && ` (${term})`
                                ]
                            }),
                            keywordList && keywordList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordList, {
                                items: keywordList
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JargonContent, {
                                question: question,
                                answer: answer,
                                image: image
                            }),
                            story.rels && story.rels.length > 0 && reducedRelatedJargon && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (jargon_module_default()).title,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            element: "h2",
                                            type: index_esm/* TextStyles.mainTitle */.k7.mainTitle,
                                            lineHeight: "display",
                                            children: "Related Jargon"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedJargon, {
                                        items: reducedRelatedJargon
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/get-static-props.ts

const getStaticPropsGenerator = ({ path  })=>{
    return async ({ params , preview =false  })=>{
        try {
            const slug = params === null || params === void 0 ? void 0 : params.slug;
            const story = await getStoryBySlug(`${path}/${slug}`, {
                version: preview ? "draft" : "published",
                cv: Date.now(),
                resolve_relations: "JargonPage.relatedJargon"
            });
            if (!story) {
                throw new Error("No story within jargon");
            }
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        }
    };
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/lib/get-static-paths.ts


const getStaticPathsGenerator = (slug)=>async ()=>{
        // Get the paths we want to pre-render based on data
        try {
            const links = await getLinks(slug);
            const paths = jargonStaticPaths({
                links
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };

;// CONCATENATED MODULE: ../../../libs/landing/feature-jargon/src/index.ts







/***/ }),

/***/ 90197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"jargon-content_content__8Wl09","question":"jargon-content_question__c69Rl","article":"jargon-content_article__z7C_Y","imageWrapper":"jargon-content_imageWrapper__1YD_H","answer":"jargon-content_answer__KiTPu","jargonImage":"jargon-content_jargonImage__EJFoL"};

/***/ }),

/***/ 55257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"keywords":"keyword-list_keywords__wVyht","header":"keyword-list_header__cfxLY","item":"keyword-list_item__UwcAk","list":"keyword-list_list__ZBBLG","link":"keyword-list_link__7OPku"};

/***/ }),

/***/ 16970:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"related":"related-jargon_related__gr6qU","link":"related-jargon_link__rtrun","button":"related-jargon_button__i0Grp"};

/***/ }),

/***/ 68740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"jargon_header__eXOCz","headerLink":"jargon_headerLink__KFplA","icon":"jargon_icon__OnRTn","page":"jargon_page__zCTys","fullTerm":"jargon_fullTerm__sPRkb","title":"jargon_title__xpSmU","skeleton":"jargon_skeleton__3BB4V"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(22352); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);